import { render, staticRenderFns } from "./WageSupplementTypeConfigurationManagement.vue?vue&type=template&id=f04e9550&scoped=true"
import script from "./WageSupplementTypeConfigurationManagement.vue?vue&type=script&lang=js"
export * from "./WageSupplementTypeConfigurationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04e9550",
  null
  
)

export default component.exports